import Hero from "../components/Hero"
import Banner from "../components/Banner";
import AboutPreview from "../components/AboutPreview";
import CasesPreview from "../components/CasesPreview";
import ReviewsPreview from "../components/ReviewsPreview";
import ResourcesPreview from "../components/ResourcesPreview";
import Contact from "../components/Contact";
import Faq from "../components/Faq";
import CtaButton from "../components/CtaButton";
import { faqData } from "../data/faqData";
import { usePageTitle } from "../hooks/usePageTitle";

export default function Home() {

	usePageTitle();

	return (
		<>
			<Hero />
			<Banner />
			<AboutPreview />
			<CasesPreview />
			<ResourcesPreview />
			<ReviewsPreview />
			<Faq
				// Preview: the first few questions, with a CTA to the full FAQ page
				items={faqData.slice(0, 5)}
				footer={
					<CtaButton to={"/faq"}>
						View All FAQs
					</CtaButton>
				}
			/>
			<Contact />
		</>
	);
}
